import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

const PDFOptions = ({
  sections,
  value,
  withVariables,
  onChange,
  onVariablesChange,
  exportAsZip,
  onExportAsZipChange
}) => {
  useEffect(() => {
    const $select = window.$('.selectpicker')
    $select.selectpicker('refresh')
  }, [value, sections])

  const handleChange = useCallback(event => {
    const selectedValues = Array.from(event.target.selectedOptions).map(option =>
      parseInt(option.value, 10)
    )
    onChange(selectedValues)
  }, [onChange])

  const handleExportAsZipChange = useCallback(event => {
    onExportAsZipChange(event.target.value === 'true')
  }, [onExportAsZipChange])

  return (
    <div className="pdf-options">
      <div className="form-group">
        <label>Sections</label>
        <select
          className="form-control selectpicker"
          data-live-search="true"
          data-actions-box="true"
          value={value}
          multiple
          onChange={handleChange}
        >
          {sections.map(section =>
            <option key={section.id} value={section.id}>{section.name}</option>
          )}
        </select>
        <div className="mt-4">
          <input
            type="checkbox"
            id="export_variables"
            checked={withVariables}
            onChange={onVariablesChange}
          />
          <label htmlFor="export_variables" className="ml-2">
            Ajouter les variables des ressources
          </label>
        </div>
        <div className="mt-2">
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="pdf-format-multiple"
              name="pdf-format"
              value="true"
              checked={exportAsZip === true}
              onChange={handleExportAsZipChange}
            />
            <label className="form-check-label" htmlFor="pdf-format-multiple">
              Plusieurs PDF (fichier ZIP)
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="pdf-format-single"
              name="pdf-format"
              value="false"
              checked={exportAsZip === false}
              onChange={handleExportAsZipChange}
            />
            <label className="form-check-label" htmlFor="pdf-format-single">
              PDF unique
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

PDFOptions.propTypes = {
  exportAsZip: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onExportAsZipChange: PropTypes.func.isRequired,
  onVariablesChange: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired
  })).isRequired,
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  withVariables: PropTypes.bool.isRequired
}

PDFOptions.defaultProps = {
  exportAsZip: true
}

export default PDFOptions